
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/asuransi-gadget",
      function () {
        return require("private-next-pages/asuransi-gadget.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/asuransi-gadget"])
      });
    }
  